var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgMenu(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 27 27' }, props),
        React.createElement("path", { d: 'M14 .25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm0 1.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm0 17.5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm0 1.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zM26.75 14a3.75 3.75 0 10-7.5 0 3.75 3.75 0 007.5 0zm-1.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-17.5-1a3.75 3.75 0 10-7.5 0 3.75 3.75 0 007.5 0zm-1.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z' })));
}
export default SvgMenu;
//# sourceMappingURL=Menu.js.map